(() => {
    // Debug flag
    const DEBUG = false;

    // Store rb-items and their states
    const rbItems = new Map();
    let sectionStates = []; // Make sectionStates accessible globally
    let sections; // Declare sections globally so it can be accessed by showSection
    let currentSection = null; // Declare currentSection globally
    let rbLeftValue = null;
    let isMultipleGroups = true; // Track if multiple groups are present
    
    function log(...args) {
        if (DEBUG) console.log('[Bundle Preview]:', ...args);
    }

    // Check if elements exist
    function validateElements() {
        const container = document.querySelector("#recharge-bundles");
        const items = document.querySelectorAll(".rb-item");
        log('Found container:', !!container, 'Items:', items.length);
        return container && items.length > 0;
    }

    // Add this function near the top-level of your script
    function observeIsMultipleGroups() {
        const observer = new MutationObserver(() => {
            const progressBar = document.querySelector('.rb-progress-bar[data-rb-left]');
            if (progressBar) {
                rbLeftValue = parseInt(progressBar.getAttribute('data-rb-left'), 10);
                isMultipleGroups = false;
                log('Global rbLeftValue set to:', rbLeftValue);
                observer.disconnect(); // Stop observing once found
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Also check immediately in case the element is already present
        const progressBar = document.querySelector('.rb-progress-bar[data-rb-left]');
        if (progressBar) {
            rbLeftValue = parseInt(progressBar.getAttribute('data-rb-left'), 10);
            isMultipleGroups = false;
            log('Global rbLeftValue set to:', rbLeftValue);
            observer.disconnect();
        }
    }


    // Initialize when DOM is ready
    function init() {
        log('Initializing bundle preview...');
        if (!validateElements()) {
            log('Required elements not found, retrying in 500ms...');
            setTimeout(init, 500);
            return;
        }

        observeIsMultipleGroups();
        createPreviewSection();
        log('Bundle preview initialized');
        hideProgressBar(); // Ensure progress bar is hidden after initialization
        waitForElement('#recharge-bundles', (container) => {
            waitForElement('.rb-section-title', () => {
                addStepNumbers(container);
                observeRechargeBundles(container); // Detect dynamic updates
            });
        });
        observeQtyButtons(); // Initialize observer for qty buttons
    }

    function waitForElement(selector, callback, maxAttempts = 20, intervalTime = 500) {
        let attempts = 0;
        const interval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(interval);
                log(`Found ${selector} after ${attempts} attempts`);
                callback(element);
            }
            attempts++;
            if (attempts >= maxAttempts) {
                clearInterval(interval);
                log(`Failed to find ${selector} after ${maxAttempts} attempts`);
            }
        }, intervalTime);
    }

    function addStepNumbers(container) {
        const sectionTitles = container.querySelectorAll('.rb-section-title');
        if (sectionTitles.length === 0) {
            log('No .rb-section-title elements found.');
            return;
        }
        log(`Found ${sectionTitles.length} .rb-section-title elements`);
        sectionTitles.forEach((title, index) => {
            if (!title.dataset.step) { // Prevent duplicate modifications
                title.dataset.step = index + 1;
                // Remove everything before and including " - "
                let text = title.innerHTML.trim();
                let cleanedText = text.includes(" - ") ? text.split(" - ").slice(1).join(" - ") : text;
                title.innerHTML = `<span class="step-number">Step ${index + 1}: </span>${cleanedText}`;
            }
        });
    }

    function observeRechargeBundles(container) {
        log('Observing changes in Recharge bundle...');
        const observer = new MutationObserver(() => {
            log('Mutation detected. Updating step numbers...');
            addStepNumbers(container);
        });
        observer.observe(container, { childList: true, subtree: true });
    }

    function waitForRechargeWidget(callback) {
        const container = document.querySelector("#recharge-bundles");
        if (!container) {
            log("Recharge container not found.");
            return;
        }
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList") {   
                    const remainderElements = isMultipleGroups ? document.querySelectorAll('.rb-remainder > span:not(.rb-complete)') : document.querySelector('.rb-progress-bar[data-rb-left]');
                    if (remainderElements.length > 0 || remainderElements) {
                        observer.disconnect(); // Stop observing once found
                        callback();
                        return;
                    }
                }
            }
        });
        observer.observe(container, { childList: true, subtree: true });
    }

    function createPreviewSection() {
        const existing = document.getElementById("selected-products-preview");
        if (existing) existing.remove();
        waitForRechargeWidget(() => {
            if (isMultipleGroups) {
                // Extract all numbers from `.rb-remainder > span`
                const remainderElements = document.querySelectorAll('.rb-remainder > span');
                let maxSelections = 0;
                remainderElements.forEach(el => {
                    const match = el.textContent.match(/\d+/); // Extract numbers
                    if (match) {
                        maxSelections += parseInt(match[0], 10); // Sum up the numbers
                    }
                });
                if (maxSelections === 0) {
                    log('No valid selections found. Defaulting to 1.');
                    maxSelections = 1; // Prevent empty previews
                }
            } else {
                // For single group, use the rbLeftValue        
                if (rbLeftValue === null) {
                    log('rbLeftValue is null, defaulting to 1.');          
                    rbLeftValue = 1; // Default to 1 if no value found
                }
                maxSelections = rbLeftValue;
            }
            log('Total maxSelections:', maxSelections);
            const preview = document.createElement("div");
            preview.id = "selected-products-preview";
            // Create placeholder boxes with numbers below
            const placeholders = Array.from({ length: maxSelections }, (_, i) => `
                <div class="selected-product empty" data-product-id="">
                    <div class="placeholder-content"></div>
                    <div class="count-box">${i + 1}</div>
                </div>
            `).join('');
            preview.innerHTML = `<div class="selected-items">${placeholders}</div>`;
            const container = document.querySelector("#recharge-bundles");
            container.parentNode.insertBefore(preview, container);
            log('Preview section created with', maxSelections, 'slots');
        });
    }
    
    function addToPreview(rbItem) {
        log('section states:', sectionStates);
        const productId = rbItem.getAttribute("data-rb-item-id");
        const productTitle = rbItem.querySelector(".rb-title, .rb-item-content .tf4")?.innerText;
        const productImage = rbItem.querySelector(".rb-item-img img, .rb-img img")?.src;
        log('addToPreview called with:', { productId, productTitle, productImage });
        if (!productId || !productTitle || !productImage) {
            log('ERROR: Missing product details:', { productId, productTitle, productImage });
            return;
        }
        const selectedItems = document.querySelector(".selected-items");
        const emptySlot = selectedItems.querySelector('.selected-product.empty');
        if (!emptySlot) {
            log("No empty slots available to add the product.");
            return;
        }
        // Explicitly determine the active section
        const activeSection = sections.find(section => section.style.display === "block");
        if (!activeSection) {
            log("No active section found.");
            return;
        }
        // Match the active section with its state
        const currentSection = sectionStates.find(state => state.element === activeSection);
        if (!currentSection) {
            log("No matching section state found for the active section.");
            return;
        }
        const requiredItems = currentSection.requiredProducts;
        log(`Required items for section ${currentSection.index + 1}:`, requiredItems);
        if (currentSection.productIds.length >= requiredItems) {
            log(`Maximum products reached for section ${currentSection.index + 1}.`);
            return;
        }
        const placeholderContent = emptySlot.querySelector('.placeholder-content');
        if (!placeholderContent) {
            log('ERROR: placeholderContent not found in empty slot:', emptySlot);
            return;
        }
        // Add product to the preview
        placeholderContent.innerHTML = `
            <img src="${productImage}" alt="${productTitle}" class="preview-img">
        `;
        log('Added product to placeholderContent:', productId);
        emptySlot.classList.remove('empty');
        emptySlot.dataset.productId = productId;

         // Scroll to preview section
         const previewSection = document.getElementById('selected-products-preview');
         if (previewSection) {
             previewSection.scrollIntoView({ 
                 behavior: 'smooth',
                 block: 'center'
             });
         }
         
        log('Added product to slot:', productId);
        // Update sectionStates to add the product ID
        currentSection.productIds.push(productId);
        log('Updated sectionStates:', sectionStates);
        // Check if the current section is complete
        const totalSelected = currentSection.productIds.length;
        if (totalSelected >= requiredItems) {
            log(`Section ${currentSection.index + 1} is complete.`);
            setTimeout(() => {
                if (currentSection.productIds.length === currentSection.requiredProducts) {
                    showSection(currentSection.index + 1); // Use showSection to transition to the next section
                } else {
                    log(`Cannot transition to the next section. Required: ${currentSection.requiredProducts}, Selected: ${currentSection.productIds.length}`);
                }
            }, 100); // Small delay to ensure DOM updates are complete
        } else {
            log(`Section ${currentSection.index + 1} is not yet complete. Selected: ${totalSelected}, Required: ${requiredItems}`);
        }
    }

    function removeFromPreview(rbItem) {
        const productId = rbItem.getAttribute("data-rb-item-id");
        log('Removing product:', productId);

        const productElements = document.querySelectorAll(`.selected-product[data-product-id="${productId}"]`);
        let productElement = null;
        if (productElements.length > 1) {
            productElement = productElements[productElements.length - 1];
            log('Found multiple product elements with the same ID, selecting the last one:', productElement);
        } else if (productElements.length === 1) {
            productElement = productElements[0];
            log('Found a single product element with the ID:', productElement);
        } else {
            log('No product elements found with the ID:', productId);
        }
        
        if (productElement) {
            const placeholderContent = productElement.querySelector(".placeholder-content");
            if (placeholderContent) {
                placeholderContent.innerHTML = "";
            }

            productElement.classList.add('empty');
            productElement.dataset.productId = "";

            // Scroll to preview section
            const previewSection = document.getElementById('selected-products-preview');
            if (previewSection) {
                previewSection.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'center'
                });
            }
            // Update sectionStates to remove only the last occurrence of the product ID
            sectionStates.forEach(state => {
                debugger
                const lastIndex = state.productIds.lastIndexOf(productId); // Find the last occurrence
                if (lastIndex !== -1) {
                    state.productIds.splice(lastIndex, 1); // Remove the last occurrence
                    log(`Removed last occurrence of product ID: ${productId} from section index: ${state.index}`);
                    log('Updated sectionStates:', sectionStates);
                }
            });
        }
    }

    // Hide the progress bar when it appears
    function hideProgressBar() {
        const observer = new MutationObserver(() => {
            const progressBar = document.querySelector('body.recharge-page-bundle .rb-progress-bar-wrapper');
            if (progressBar) {
                progressBar.style.display = 'none';
                observer.disconnect(); // Stop observing once hidden
                log('Progress bar hidden');
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
        // Also try hiding it after a delay in case it's already there
        setTimeout(() => {
            const progressBar = document.querySelector('body.recharge-page-bundle .rb-progress-bar-wrapper');
            if (progressBar) {
                progressBar.style.display = 'none';
                log('Progress bar hidden via timeout');
            }
        }, 500);
    }


    function makePreviewSticky() {
        log('Initializing makePreviewSticky...');
    
        function applyStickyBehavior() {
            const preview = document.getElementById('selected-products-preview');
            const header = document.getElementById('shopify-section-custom-header');
            const rbBtnWrapper = document.querySelector('.rb-sticky-form');
    
            if (!preview || !header || !rbBtnWrapper) {
                log('Preview or button wrapper not found, retrying...');
                setTimeout(makePreviewSticky, 500); // Retry after delay
                return;
            }
    
            log('Applying sticky behavior...');
            const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
    
            function onScroll() {
                if (window.scrollY >= headerBottom) {
                    preview.classList.add('is-sticky');
                    preview.style.position = 'fixed';
                    preview.style.top = `${header.offsetHeight}px`;
                    preview.style.width = `${preview.parentElement.clientWidth}px`;
                    preview.style.zIndex = '3';
    
                    rbBtnWrapper.style.position = 'fixed';
                    rbBtnWrapper.style.top = `${header.offsetHeight + preview.offsetHeight}px`;
                    rbBtnWrapper.style.width = `100%`;
                    rbBtnWrapper.style.zIndex = '3';
                    rbBtnWrapper.style.left = '0';
                } else {
                    preview.classList.remove('is-sticky');
                    preview.style.position = '';
                    preview.style.top = '';
                    preview.style.width = '';
    
                    rbBtnWrapper.style.position = '';
                    rbBtnWrapper.style.top = '';
                    rbBtnWrapper.style.width = '';
                    rbBtnWrapper.style.left = '';
                }
            }
    
            window.addEventListener('scroll', onScroll);
        }
    
        // Use MutationObserver to ensure preview exists before executing
        const observer = new MutationObserver(() => {
            const preview = document.getElementById('selected-products-preview');
            const rbBtnWrapper = document.querySelector('.rb-sticky-form');
            if (preview && rbBtnWrapper) {
                observer.disconnect();
                applyStickyBehavior();
            }
        });
    
        observer.observe(document.body, { childList: true, subtree: true });
    
        // Also try after a delay in case observer misses it
        setTimeout(applyStickyBehavior, 1000);
    }

    function createLeftArrow() {
        const button = document.createElement("button");
        button.classList.add("left-arrow");
        button.innerHTML = "&#8592;"; // Left arrow symbol (←)
        button.style.background = "none";
        button.style.border = "none";
        button.style.fontSize = "24px";
        button.style.cursor = "pointer";
        button.style.zIndex = "10"; // Ensure it appears above other elements
        button.style.float = "left";
        return button;
    }

    function removeLastSelectedProduct() {
        log("removeLastSelectedProduct called.");
        const selectedItems = document.querySelector(".selected-items");
        if (!selectedItems) {
            log("No .selected-items container found.");
            return null;
        }

        // Find the last non-empty selected product
        const selectedProducts = Array.from(selectedItems.querySelectorAll(".selected-product:not(.empty)"));
        log("Selected products:", selectedProducts);

        if (selectedProducts.length > 0) {
            const lastProduct = selectedProducts[selectedProducts.length - 1];
            const productId = lastProduct.dataset.productId;

            // Find the section associated with the removed product ID
            const sectionIndex = getSectionForProduct(productId);
            if (sectionIndex !== null) {
                log(`Product belongs to section index: ${sectionIndex}`);

                // Click the .rb-btn-remove or .rb-btn-qty-minus button of the removed product
                const rbItem = document.querySelector(`[data-rb-item-id="${productId}"]`);
                if (rbItem) {
                    const removeButton = rbItem.querySelector(".rb-btn-remove") || rbItem.querySelector(".rb-btn-qty-minus");
                    
                    if (removeButton) {
                        removeButton.click();
                        log("Clicked remove button for product ID:", productId);
                    } else {
                        log(`Remove button not found for product ID: ${productId}`);
                    }
                }

                // Clear the preview slot for the removed product
                lastProduct.classList.add("empty");
                lastProduct.dataset.productId = "";
                const placeholderContent = lastProduct.querySelector(".placeholder-content");
                if (placeholderContent) {
                    placeholderContent.innerHTML = "";
                }

                return sectionIndex; // Return the section index of the removed product
            } else {
                log("No associated section found for the removed product.");
            }
        } else {
            log("No non-empty selected products to remove.");
        }

        return null; // Return null if no product was removed
    }

    // Add the resetAllSections function here or near other utility functions
    async function resetAllSections() {
        log('Resetting all sections by setting non-zero quantity inputs to 0 and triggering enter...');

        // 1. Clear the sectionStates array
         showSection(0); // Show the first section to reset the view
        // sectionStates = [];
        log('sectionStates cleared.');

        if (isMultipleGroups) {
            const selectedProducts = document.querySelectorAll(".selected-product");
            selectedProducts.forEach(product => {
                product.classList.add("empty");
                product.dataset.productId = "";
                const placeholderContent = product.querySelector(".placeholder-content");
                if (placeholderContent) {
                    placeholderContent.innerHTML = "";
                }
            });
        }
        // 3. Iterate through quantity inputs, set to 0 if not already, and trigger enter
        const allRbItems = document.querySelectorAll(".rb-item");
        allRbItems.forEach(async item => {
            const qtyInput = item.querySelector('.rb-qty-wrapper .rb-input');
            const minusButton = item.querySelector('.rb-qty-wrapper .rb-btn-qty-minus');

            if (qtyInput && minusButton) {
                const currentQuantity = parseInt(qtyInput.value, 10);

                // Check if the current quantity is not 0
                if (currentQuantity > 0) {
                    for (let i = 0; i < currentQuantity; i++) {
                        debugger
                        qtyInput.value = 0; // Set the input value to 0
                        minusButton.click();
                        await new Promise(resolve => setTimeout(resolve, 100));

                    }
                    sectionStates.forEach(obj => {
                        obj.productIds = [];
                    });
                }
            }
        });

        
        let rbItemButtons = document.querySelectorAll(".rb-item-btn-wrapper > button");
        rbItemButtons.forEach(button => {
            button.click();
        });
        log('All sections reset process initiated.');
    }

    function showSection(index) {
        sections.forEach((section, i) => {
            section.style.display = i === index ? "block" : "none";
        });

        // Update the global currentSection
        currentSection = sectionStates.find(state => state.index === index);
        log(`Updated currentSection to section ${index + 1}:`, currentSection);

        // Show the reset button only after the last section
        const resetButton = document.querySelector(".reset-button");
        if (index === sections.length) {
            resetButton.style.display = "block"; // Show reset button
            log("Reset button is now visible.");
        } else {
            resetButton.style.display = "none"; // Hide reset button
        }

        log(`Showing section ${index + 1}`);
    }

    function initRbSections() {
        // Try to get .rb-section first
        sections = Array.from(document.querySelectorAll(".rb-section"));

        // Fallback: If no .rb-section, use .rb-collapsible-container
        if (sections.length === 0) {
            sections = Array.from(document.querySelectorAll(".rb-collapsible-container"));
            if (sections.length === 0) {
                log("No .rb-section or .rb-collapsible-container elements found. Retrying in 500ms...");
                setTimeout(initRbSections, 500);
                return;
            }
            // For collapsible layout, get max selection from .rb-progress-bar[data-rb-left]
            sectionStates = sections.map((section, index) => {
                const progressBar = isMultipleGroups ? section.querySelector('.rb-progress-bar[data-rb-left]') : document.querySelector('.rb-progress-bar[data-rb-left]');
                let requiredProducts = 0;
                if (progressBar) {
                    const left = parseInt(progressBar.getAttribute('data-rb-left'), 10);
                    const added = parseInt(progressBar.getAttribute('data-rb-added'), 10) || 0;
                    requiredProducts = left + added;
                }
                return {
                    element: section,
                    index,
                    productIds: [],
                    requiredProducts,
                };
            });
        } else {
            // Standard .rb-section logic
            sectionStates = sections.map((section, index) => {
                const rbRemainderSpan = section.querySelector('.rb-remainder > span:not(.rb-complete)');
                let requiredProducts = 0;
                if (rbRemainderSpan) {
                    const match = rbRemainderSpan.textContent.match(/\d+/);
                    if (match) requiredProducts = parseInt(match[0], 10);
                }
                return {
                    element: section,
                    index,
                    productIds: [],
                    requiredProducts,
                };
            });
        }

        let currentIndex = 0;
        const stiickyWrap = document.querySelector(".rb-sticky-form .rb-container");

        // Create the reset button
        const resetButton = document.createElement("button");
        resetButton.textContent = "Restart Build";
        resetButton.classList.add("reset-button");
        resetButton.style.margin = "0 auto";
        resetButton.style.color = "#000";
        resetButton.style.cursor = "pointer";
        resetButton.style.fontSize = "16px";
        resetButton.style.textDecoration = "underline";
        resetButton.style.background = "none";
        resetButton.style.border = "none";
        resetButton.style.display = "none"; // Initially hide the reset button
        resetButton.addEventListener("click", resetAllSections);
    
        const lastSection = sections[sections.length - 1];
        lastSection.parentNode.appendChild(resetButton);
    
        // Show only the first section initially
        showSection(currentIndex);
    
        // Add the left arrow to the .rb-header
        const leftArrow = createLeftArrow();
        leftArrow.addEventListener("click", () => {
            leftArrow.dataset.listenerAttached = true;
            log("Left arrow clicked.");
            const removedSectionIndex = removeLastSelectedProduct();
            if (removedSectionIndex !== null) {
                // Navigate to the section where the removed product belonged
                currentIndex = removedSectionIndex;
                showSection(currentIndex);
                log(`Navigated back to section ${currentIndex + 1} after product removal.`);
            } else if (currentIndex > 0) {
                // If no product was removed but we're not in the first section, go back
                currentIndex--;
                showSection(currentIndex);
                log(`Navigated back to section ${currentIndex + 1}.`);
            } else {
                log("Already at the first section.");
                showSection(0); // Ensure the first section is displayed
            }
        });
        stiickyWrap.style.position = "relative"; // Ensure the header is positioned for absolute child
        stiickyWrap.appendChild(leftArrow);
    }

    function getSectionForProduct(productId) {
        // Find the section index for the given product ID
        for (const state of sectionStates) {
            if (state.productIds.includes(productId)) {
                return state.index;
            }
        }
        return null; // Return null if the product is not found in any section
    }

    function observeQtyButtons() {
        const container = document.querySelector('#recharge-bundles');
        if (!container) {
            log('Recharge bundles container not found. Retrying in 500ms...');
            setTimeout(observeQtyButtons, 500);
            return;
        }
    
        const observer = new MutationObserver(() => {
            const items = container.querySelectorAll('[data-rb-item-id]');
            items.forEach(item => {
                const addButtonWrapper = item.querySelector('.rb-item-btn-wrapper'); // For Layout 1
                const qtyWrapper = item.querySelector('.rb-qty-wrapper'); // For Layout 2
                const addButton = addButtonWrapper?.querySelector('.rb-btn-add');
                const removeButton = addButtonWrapper?.querySelector('.rb-btn-remove');
                const plusButton = qtyWrapper?.querySelector('.rb-btn-qty-plus');
                const minusButton = qtyWrapper?.querySelector('.rb-btn-qty-minus');
                const qtyInput = qtyWrapper?.querySelector('.rb-input');
    
                // Handle Layout 1 (with add/remove buttons)
                if (addButton && !addButton.dataset.listenerAttached) {
                    addButton.dataset.listenerAttached = true; // Prevent duplicate listeners
                    addButton.addEventListener('click', () => {
                        const currentSection = sectionStates.find(state => state.element.style.display === "block");
                        const requiredItems = parseInt(currentSection.element.querySelector('.rb-remainder > span:not(.rb-complete)').textContent.match(/\d+/)[0], 10);
                        const totalSelected = getTotalSelectedQuantityForSection(currentSection.index);
    
                        if (totalSelected < requiredItems) {
                            addToPreview(item);
                            updatePreview(item, 1); // Add with quantity 1 for Layout 1
                        } else {
                            log(`Maximum selections reached for section ${currentSection.index + 1}.`);
                        }
                    });
                }
    
                if (removeButton && !removeButton.dataset.listenerAttached) {
                    removeButton.dataset.listenerAttached = true; // Prevent duplicate listeners
                    removeButton.addEventListener('click', () => {
                        removeFromPreview(item);
                    });
                }
    
                // Handle Layout 2 (with plus and minus buttons)
                if (qtyWrapper && !qtyWrapper.dataset.listenerAttached) {
                    qtyWrapper.dataset.listenerAttached = true; // Prevent duplicate listeners
    
                    if (plusButton && !plusButton.dataset.listenerAttached) {
                        plusButton.dataset.listenerAttached = true; // Prevent duplicate listeners
                        plusButton.addEventListener('click', () => {
                            let quantity = parseInt(qtyInput.value, 10) || 0; // Parse the current quantity
                            const currentSection = sectionStates.find(state => state.element.style.display === "block");
                            const requiredItems = isMultipleGroups ? parseInt(currentSection.element.querySelector('.rb-remainder > span:not(.rb-complete)').textContent.match(/\d+/)[0], 10) : rbLeftValue;
                            const totalSelected = getTotalSelectedQuantityForSection(currentSection.index);
                            log('Current quantity:', quantity, 'Total selected:', totalSelected, 'Required items:', requiredItems);
                            if (totalSelected <= requiredItems && sectionStates[currentSection.index].productIds.length <= sectionStates[currentSection.index].requiredProducts) {
                                
                                qtyInput.value = quantity; // Update the input value
                    
                                addToPreview(item);
                                updatePreview(item, 1);

                                 // Reset the listenerAttached flag to allow adding the same product again
                                plusButton.dataset.listenerAttached = false;
                                qtyWrapper.dataset.listenerAttached = false;
                            } else {
                                log(`Maximum selections reached for section ${currentSection.index + 1}.`);
                            }
                        });
                    }
                    if (minusButton && !minusButton.dataset.listenerAttached) {
                        minusButton.dataset.listenerAttached = true; // Prevent duplicate listeners
                        minusButton.addEventListener('click', () => {
                            const leftArrow = document.querySelector('.left-arrow');
                            let quantity = leftArrow.dataset.listenerAttached === "true" ? parseInt(qtyInput.value - 1 , 10): parseInt(qtyInput.value, 10) || 0;
                            if (quantity >= 0) {
                                qtyInput.value = quantity;
                                removeFromPreview(item);
                                updatePreview(item, quantity);

                                // Reset the listenerAttached flag to allow adding the same product again
                                minusButton.dataset.listenerAttached = false;
                                qtyWrapper.dataset.listenerAttached = false;
                                leftArrow.dataset.listenerAttached === false 
                            }
                        });
                    }
                }
            });
        });
        observer.observe(container, { childList: true, subtree: true });
        log('Observer for qty buttons initialized.');
    }
    
    function getTotalSelectedQuantityForSection(sectionIndex) {
        // Ensure the sectionIndex is valid
        if (sectionIndex < 0 || sectionIndex >= sectionStates.length) {
            log('Error: Invalid section index provided to getTotalSelectedQuantityForSection:', sectionIndex);
            return 0; // Return 0 for an invalid index
        }

        const sectionState = sectionStates[sectionIndex];

        // Return the number of product IDs in the array
        log(`Calculating total for section ${sectionIndex}: ${sectionState.productIds.length} items selected`);
        return sectionState.productIds.length;
    }

    function updatePreview(rbItem, quantity) {
        const productId = rbItem.getAttribute("data-rb-item-id");
        const productTitle = rbItem.querySelector(".rb-title, .rb-item-content .tf4")?.innerText;
        const productImage = rbItem.querySelector(".rb-item-img img, .rb-img img")?.src;
    
        log('updatePreview called with:', { productId, productTitle, productImage, quantity });
    
        if (!productId || !productTitle || !productImage) {
            log('ERROR: Missing product details:', { productId, productTitle, productImage });
            return;
        }
    
        const selectedItems = document.querySelector(".selected-items");
        const existingSlot = selectedItems.querySelector(`.selected-product[data-product-id="${productId}"]`);
    
        if (quantity === 0) {
            // Remove product from preview if quantity is 0
            if (existingSlot) {
                existingSlot.classList.add('empty');
                existingSlot.dataset.productId = "";
                const placeholderContent = existingSlot.querySelector('.placeholder-content');
                if (placeholderContent) {
                    placeholderContent.innerHTML = "";
                    log('Removed product from preview:', productId);
                }
            }
        } else {
            // Add or update product in the preview
            let slot = existingSlot;
            if (!slot) {
                slot = selectedItems.querySelector('.selected-product.empty');
                if (!slot) {
                    log("No empty slots available to add the product.");
                    return;
                }
            }
            
            const placeholderContent = slot.querySelector('.placeholder-content');
            if (!placeholderContent) {
                log('ERROR: placeholderContent not found in slot:', slot);
                return;
            }

            placeholderContent.innerHTML = `
                <img src="${productImage}" alt="${productTitle}" class="preview-img">
            `;
            log('Updated placeholderContent for product:', productId);

            slot.classList.remove('empty');
            slot.dataset.productId = productId;
            log('Updated product in preview:', productId, 'Quantity:', quantity);
            
            
        }
    
        log('observeRbComplete called after updating preview.');
    }

    // Start initialization when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
        document.addEventListener('DOMContentLoaded', createPreviewSection);
        document.addEventListener('DOMContentLoaded', makePreviewSticky);
        window.addEventListener('resize', makePreviewSticky);
    } else {
        init();
        window.addEventListener('resize', makePreviewSticky);
        document.addEventListener('DOMContentLoaded', makePreviewSticky);
        document.addEventListener("DOMContentLoaded", initRbSections);
        document.addEventListener("DOMContentLoaded", observeQtyButtons);
    }

})();